// flow
// globals window
import configLocalJson from './local.json';
import configDevJson from './dev.json';
import configStageJson from './stage.json';
import configProdJson from './production.json';
import { getLogger } from '../utils/SearchLogger';

if (typeof window === 'undefined') {
	// @ts-ignore
	global.window = {};
}

function getConfig(env: string, key: string): string {
	if (!window.SEARCH_CONFIG) {
		switch (env) {
			case 'local':
				window.SEARCH_CONFIG = configLocalJson;
				break;

			case 'dev':
				window.SEARCH_CONFIG = configDevJson;
				break;

			case 'stage':
				window.SEARCH_CONFIG = configStageJson;
				break;

			case 'prod':
				window.SEARCH_CONFIG = configProdJson;
				break;

			default:
				window.SEARCH_CONFIG = configProdJson;
				getLogger().warn('index.js', "Didn't find window.ENV, setting window.ENV to prod", env);
				break;
		}
	}

	return window.SEARCH_CONFIG[key];
}

getConfig.config = window.SEARCH_CONFIG;
getConfig.json = JSON.stringify(window.SEARCH_CONFIG);
export default getConfig;
